import _ from 'lodash';

import { apiRequest } from 'src/api';

export const isDataValueComplete = val => {
  if (val instanceof Array) {
    if (val.length === 0) {
      return false;
    }
  } else if (!val || val === '') {
    return false;
  }

  return true;
};

export const isDataComplete = (items, dataMap) => {
  if (items == null || dataMap == null) {
    return false;
  }

  const data = items instanceof Array ? items : [items];

  let isOk = true;

  data.forEach(item => {
    if (!item) {
      isOk = false;
    } else {
      dataMap.forEach(dm => {
        const isRequired =
          typeof dm.required === 'function' ? dm.required(item) : dm.required;
        if (isRequired) {
          const val = item[dm.value];
          isOk = isOk && isDataValueComplete(val);
        }
      });
    }
  });

  return isOk;
};

export const getSubmissions = async (financialInstitutionId, accountId) => {
  return apiRequest({
    url: `/api/v1/fis/${financialInstitutionId}/accounts/${accountId}/submission/`,
    method: 'GET',
    responseDataAdapter: response =>
      response.map(s => ({
        id: s.id,
        date: s.submission_date,
        userId: _.get(s, 'submission_user.id'),
        userFirstName: _.get(s, 'submission_user.user_first_name'),
        userLastName: _.get(s, 'submission_user.user_last_name'),
      })),
  });
};
